import React from 'react';
import { Page } from './pages/Page';
import { DashboardPage, TenderListingPage, NewTenderPage, SourceDocumentsPage, FinalizedSummaryPage, ProductComparisonPage, ClientComparisonPage } from './pages';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage/LoginPage';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { LoginCallback } from './pages/LoginCallback';
import { ToastProvider } from './components/ToastProvider/ToastProvider';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <ToastProvider>
        <CssBaseline />
        <AuthProvider>
          <Router>
            <div className="App">
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/login/callback" element={<LoginCallback />} />
                
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Page><DashboardPage /></Page>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/tender-listing"
                  element={
                    <ProtectedRoute>
                      <Page><TenderListingPage /></Page>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/new-tender"
                  element={
                    <ProtectedRoute>
                      <Page><NewTenderPage /></Page>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/:tenderId/source-documents/:subStep?"
                  element={
                    <ProtectedRoute>
                      <Page><SourceDocumentsPage /></Page>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/:tenderId/finalized-summary/:subStep?"
                  element={
                    <ProtectedRoute>
                      <Page><FinalizedSummaryPage /></Page>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/:tenderId/product-comparison/:subStep?"
                  element={
                    <ProtectedRoute>
                      <Page><ProductComparisonPage /></Page>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/:tenderId/client-comparison/:subStep?"
                  element={
                    <ProtectedRoute>
                      <Page><ClientComparisonPage /></Page>
                    </ProtectedRoute>
                  }
                />

                <Route path="*" element={<Navigate to="/dashboard" />} />
              </Routes>
            </div>
          </Router>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
